import Vue from 'vue'
import VueRouter from 'vue-router'
import ComponentWrapper from './components/ComponentWrapper.vue'
import PageNotFound from './components/PageNotFound.vue'

function isLeavePage(siteconfig, path) {
    // Compare on a full path segment, so that /news-archive does not make /news a non-leaf page
    let prefix = path.replace(/\/+$/, '') + '/';
    let hasLeavePage = siteconfig.routes.find(x => {
        return x.props.path && x.props.path != path && x.props.path.indexOf(prefix) == 0;
    })

    return !hasLeavePage;
}

function initRouter(siteconfig, basepath, homepage_type) {
    const originalPush = VueRouter.prototype.push;
    VueRouter.prototype.push = function push(location, onResolve, onReject) {
        if (onResolve || onReject) {
            return originalPush.call(this, location, onResolve, onReject);
        }

        return originalPush.call(this, location).catch((err) => {
            if (VueRouter.isNavigationFailure(err)) {
                // resolve err
                return err;
            }
            // rethrow error
            return Promise.reject(err);
        })
    }

    if (!siteconfig) {
        siteconfig = {};
    }
    Vue.use(VueRouter)
  
    let routes = [
        { path: '*', component: PageNotFound, name: 'Sidan hittades inte' }
    ];
    (siteconfig.routes || []).forEach(x => {
        let route = {};
        let leaveSuffix = isLeavePage(siteconfig, x.props.path) ? '/:id?' : ''

        route.name = x.props.name;
        route.path = x.props.path + leaveSuffix;
        route.component = ComponentWrapper;
        route.props = route => ({ state: route.query.state, config: x })
        route.meta = {description: x.props.description};

        let toroute = x.props.redirect && siteconfig.routes.find(r => r.props.path == x.props.redirect);

        if (x.props.redirect && (!toroute || !toroute.props.redirect)) {
            route.beforeEnter = (to,from,next) => {
                if (!window.$vue || !window.$vue.edit) {
                    let path = x.props.redirect;
                    if (to.params.id) {
                        path += '/' + to.params.id;
                    }
                    next({path, query: to.query});
                } else {
                    next();
                }
            }
        } else {
            route.beforeEnter = (to,from,next) => {
                window.$vue?.setTitle(route);
                window.$vue?.setMetaDescription(route);
                next();
            }
        }

        routes.push(route);
    })
  
    const router = new VueRouter({
        base: basepath || '/',
        mode: 'history',
        routes,
        scrollBehavior (to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                if (to.hash) {
                    return {selector: to.hash};
                } else if (to.name == from.name) {
                    return {};
                }
                return { x: 0, y: 0 }
            }
        }
    })

    if (homepage_type == 'mb') {
        router.afterEach((to, from) => {
            if (from && to.fullPath === from.fullPath) return;
            window.$ecommercetracking.pageView(to.name + ' - ' + siteconfig.root.props.title, to.fullPath);
        });
    }

    return router;
}

function addRoute(x, router) {
    let route = {};
    let leaveSuffix = isLeavePage(window.$vue.siteconfig, x.props.path) ? '/:id?' : ''
    route.name = x.props.name;
    route.path = x.props.path + leaveSuffix;
    route.component = ComponentWrapper;
    route.props = route => ({ state: route.query.state, config: x })
    router.addRoutes([route]);
}

export {initRouter, addRoute};
